import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import SessionModule from './session';
import { Settings } from '~/services/settings';

export interface IEligibilityQuestions {
    surveySessionId: string;
    questionId: number;
    answerId: number;
}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    @Resolve
    public session!: SessionModule;

    public eligibilityData = [] as SurveySessionValueModel[];

    public isEligible = false;

    public ReturnURLSurveyData = [] as SurveySessionValueModel[];

    public isPatient17YearOld = '' as string;

    public prescriptionInsuranceType = '' as string;

    public programId = '' as string;

    @Mutation
    public async updateEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.eligibilityData) {
        this.eligibilityData = newEligibilityData;
    }

    @Mutation

    public async updateReturnURLSurveyData(newReturnURLSurveyData: typeof EligibilityModule.prototype.ReturnURLSurveyData) {
        this.ReturnURLSurveyData = newReturnURLSurveyData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Mutation
    public addOrUpdateEligibilityData(newItem: SurveySessionValueModel) {
        const newEligibilityData = this.eligibilityData.filter(item =>
            item.questionId !== newItem.questionId
        );
        newEligibilityData.push(newItem);
        this.eligibilityData = newEligibilityData;
    }

    @Mutation
    public async addEligiblityData(newEligibilityData: SurveySessionValueModel) {
        const searchItem = this.eligibilityData.filter(item => {
            if (item.questionId === newEligibilityData.questionId) return item;
            else return null;
        });
        const index = this.eligibilityData.indexOf(searchItem[0]);
        if (index > -1) {
            this.eligibilityData[index] = newEligibilityData;
        } else {
            this.eligibilityData.push(newEligibilityData);
        }
    }

    @Mutation
    public async updatePatientAge(patientAge: string) {
        this.isPatient17YearOld = patientAge;
    }

    @Mutation
    public async updatePrescriptionInsuranceType(prescriptionInsuranceType: string) {
        this.prescriptionInsuranceType = prescriptionInsuranceType;
    }

    @Mutation
    public async updateProgramId(programId: string) {
        this.programId = programId;
    }

    @Action({ rawError: true })
    public async clearStore() {
        this.updateEligibilityData([]);
        this.updateIsEligible(false);
        this.updatePatientAge('');
        this.updatePrescriptionInsuranceType('');
        this.updateProgramId('');
    }


    @Action({ rawError: true })
    public checkEligibility(eligibilityData: SurveySessionValueModel[]): boolean {
        const correctAnswers = [
        ] as number[];

        const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
        this.updateIsEligible(isEligible);
        return isEligible;
    }
}
